<template>
  <v-container class="mx-2">
    <v-row>
      <v-col cols="12" lg="11">
        <v-breadcrumbs
          class="pl-0 pt-0"
          :items="items"
        ></v-breadcrumbs>
        <h1 class="mb-2">{{ $route.meta.title }}</h1>
        <v-row>
          <v-col cols="8" sm="5" class="pb-0">
            <v-text-field
              ref="codeKey"
              v-model="codeKey"
              label="Код ключа"
              outlined
              dense
              :rules="[
                () => !!codeKey || 'Обязательное поле',
                () => /^[0-9A-F]*$/.test(codeKey) || 'Поле должно содержать цифры и заглавные символы латиницы (A-F)',
              ]"
            ></v-text-field>
          </v-col>
          <v-col cols="8" sm="5" class="pb-0">
            <v-text-field
              ref="nameKey"
              v-model="nameKey"
              label="Номер квартиры"
              outlined
              dense
              :maxlength=64
            ></v-text-field>
          </v-col>
          <v-col cols="8" sm="5" class="pb-0">
            <v-select
              v-model="selectedType"
              :items="typeKey"
              item-value="id"
              item-text="value"
              placeholder="Тип ключа"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="8" sm="5" class="pb-0">
            <v-text-field
              ref="comment"
              v-model="comment"
              label="Комментарий"
              outlined
              dense
              :maxlength=64
            ></v-text-field>
          </v-col>
          <v-col cols="8" sm="5" class="pb-0">
          <v-checkbox
            v-if="displayDuplicate"
            v-model="keyDuplicate"
            label="Дублировать ключ в дополнительный вход"
            hide-details
            dense
            color="success"
          />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>Внутренний считыватель</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-checkbox v-model="internal_reader" value="1" label="Замок A" hide-details></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="internal_reader" value="2" label="Замок B" hide-details></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="internal_reader" value="3" label="Замок C" hide-details></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title>Внешний считыватель</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-checkbox v-model="external_reader" value="1" label="Замок A" hide-details></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="external_reader" value="2" label="Замок B" hide-details></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="external_reader" value="3" label="Замок C" hide-details></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card-actions class="pl-0">
          <div class="my-2">
            <v-btn
              large
              color="success"
              class="ma-1 text-none"
              dark
              @click.prevent="saveChanges"
              :disabled="!valid"
            >
              Сохранить
            </v-btn>
            <v-btn
              large
              color="primary"
              outlined
              class="ma-1 text-none"
              dark
              @click.prevent="readKey()"
            >
              Считать
            </v-btn>
            <v-btn
              @click.prevent="cancelChanges"
              large
              class="ma-1 text-none"
              outlined
              dense
              hide-details
              color="error"
            >
              Отменить
            </v-btn>
          </div>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NewAccessKey',
  props: ['id'],
  data () {
    return {
      errorEmailExist: false,
      valid: true,
      keyDuplicate: true,
      codeKey: '',
      nameKey: '',
      comment: '',
      include: ['gates,additionalEntrances,mainDoorphones'],
      items: [
        {
          text: 'Домофон',
          disabled: false,
          href: '/doorphones/' + this.$route.params.id,
        },
        {
          text: 'Новый ключ домофона',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
      typeKey: [
        {
          id: 0,
          value: 'Неуниверсальный',
        },
        {
          id: 1,
          value: 'Универсальный',
        },
      ],
      selectedType: 0,
      internal_reader: ['1'],
      external_reader: ['2'],
    };
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
      role: 'role',
    }),
    displayDuplicate () {
      return (this.doorphone.type === 'M') && ((this.doorphone.additionalEntrances.length > 0) || (this.doorphone.gates.length > 0));
    },
    form () {
      return {
        nameKey: this.nameKey,
        codeKey: this.codeKey,
        comment: this.comment,
      };
    },
    formErrors () {
      let resultError = false;

      for (const key in this.$refs) {
        if (this.$refs[key].hasError) {
          resultError = true;
        }
      }

      return resultError;
    },
  },
  created () {
    const options = {
      include: this.include,
    };
    this.loadDoorphone({
      id: this.$route.params.id,
      options,
    });
  },
  methods: {
    ...mapActions({
      loadDoorphone: 'Doorphone/getDoorphone',
      newKey: 'Keys/newDoorphoneKey',
      toReadKey: 'Keys/readKey',
    }),
    readKey () {
      this.toReadKey()
        .then((response) => {
          if (response) {
            this.codeKey = response.data;
          } else {
            this.$flash_warning('Поднесите ключ к считывателю');
          }
        })
        .catch(e => {
          this.$flash_warning('Проверьте подключение к считывателю');
          console.error(e);
        });
    },
    saveChanges () {
      Object.keys(this.form).forEach(f => {
        this.$refs[f].validate(true);
      });

      this.$nextTick(() => {
        if (!this.formErrors) {
          const tempKey = {
            code: this.codeKey,
            universal: this.selectedType,
            duplicate: +this.keyDuplicate,
            comment: this.comment,
          };

          if (this.nameKey) {
            tempKey.name = this.nameKey;
          }

          const internalReaders = this.internal_reader.sort().join('');
          const externalReaders = this.external_reader.sort().join('');
          tempKey.doornum = (internalReaders === '') ? 0 : parseInt(internalReaders);
          tempKey.ext_reader_doornum = (externalReaders === '') ? 0 : parseInt(externalReaders);

          this.newKey({
            doorphoneId: this.$route.params.id,
            key: tempKey,
          })
            .then(() => {
              this.$flash_success('Ключ успешно создан');
              this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
            })
            .catch((message) => {
              if (message.length > 0) {
                for (let i = 0; i < message.length; i++) {
                  this.$flash_warning(message[i]);
                }
              } else {
                this.$flash_warning('Ошибка при создании ключа');
              }
            });
        }
      });
    },
    cancelChanges () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
